const config = {
    API_URL: 'https://api.sdmpalumniassociation.in/api'
};

export default config;
